import { throttle } from '@portals/shared-frontend/utils';
import { useCallback, useEffect, useState } from 'react';

import { NAVBAR_HEADER_HEIGHT } from '@/constants';

export function useScrollSpy(ids: string[]) {
  const [activeId, setActiveId] = useState<string | null>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = useCallback(
    throttle(() => {
      let closestOffset = -Infinity;
      let closestId: string | null = null;
      for (const id of ids) {
        // Elements are loaded on each scroll, as they might not be in the DOM when the hook is first initialized.
        const element = document.getElementById(id);
        if (!element) continue;
        const offset = element.getBoundingClientRect().top - NAVBAR_HEADER_HEIGHT;
        // Add a 10px threshold to trigger the active state a bit earlier
        if (offset <= 10 && offset > closestOffset) {
          closestId = element.id;
          closestOffset = offset;
        }
      }
      setActiveId(closestId);
    }, 50),
    [ids],
  );

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return activeId;
}
